module.exports = __webpack_public_path__ + "img/vignettes-asso_0012_un-avenir-ensemble.9456b8af.jpg";